var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOffer5(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0H36C42.6274 0 48 5.37258 48 12V36C48 42.6274 42.6274 48 36 48H12C5.37258 48 0 42.6274 0 36V12Z",
    fill: "#E8F4FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.83 14.18C24.5694 14.0611 24.2864 13.9996 24 13.9996C23.7136 13.9996 23.4306 14.0611 23.17 14.18L14.6 18.08C14.4225 18.1582 14.2717 18.2864 14.1658 18.4488C14.0598 18.6113 14.0034 18.8011 14.0034 18.995C14.0034 19.1889 14.0598 19.3787 14.1658 19.5411C14.2717 19.7036 14.4225 19.8317 14.6 19.91L23.18 23.82C23.4406 23.9388 23.7236 24.0003 24.01 24.0003C24.2964 24.0003 24.5794 23.9388 24.84 23.82L33.42 19.92C33.5974 19.8417 33.7483 19.7136 33.8542 19.5511C33.9601 19.3887 34.0165 19.1989 34.0165 19.005C34.0165 18.8111 33.9601 18.6213 33.8542 18.4588C33.7483 18.2964 33.5974 18.1682 33.42 18.09L24.83 14.18Z",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 24C13.9995 24.1913 14.0539 24.3787 14.1567 24.5399C14.2595 24.7012 14.4064 24.8297 14.58 24.91L23.18 28.82C23.4392 28.9374 23.7205 28.9981 24.005 28.9981C24.2895 28.9981 24.5708 28.9374 24.83 28.82L33.41 24.92C33.587 24.8404 33.737 24.7111 33.8418 24.5477C33.9466 24.3844 34.0015 24.1941 34 24",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 29C13.9995 29.1913 14.0539 29.3787 14.1567 29.5399C14.2595 29.7012 14.4064 29.8297 14.58 29.91L23.18 33.82C23.4392 33.9374 23.7205 33.9981 24.005 33.9981C24.2895 33.9981 24.5708 33.9374 24.83 33.82L33.41 29.92C33.587 29.8404 33.737 29.7111 33.8418 29.5477C33.9466 29.3844 34.0015 29.1941 34 29",
    stroke: "#057DCD",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffer5);
export default __webpack_public_path__ + "static/media/offer5.3b5279d2060eb95146492436555c2277.svg";
export { ForwardRef as ReactComponent };